<!--  -->
<template>
  <cc-container>
    <cc-header-nav>
      <template slot="center">
          <van-search class="search-input" placeholder="通用名" v-model="params.search" />
      </template>
      <template slot="right">
        <div class="search-btn" @click="toSearch">搜索</div>
      </template>
    </cc-header-nav>
    <!-- 筛选抽屉 -->
    <cc-drawer v-model="showDrawer" v-on:reset="reset" v-on:confirm="confirm">
      <div class="filtrate-model">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            v-for="(item,index) in filterSelect"
            :key="index"
            :title="item.title"
            :value="item.value"
            :name="index">
            <div class="btns">
              <span
                v-for="(btn,key) in item.arr"
                :class="{active:btn.state}"
                @click="selectedFliter(index,key)"
                :key="key">
                {{btn.name}}
              </span>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </cc-drawer>
       <!-- 商品分类tabs -->
    <ul class="filter-tabs">
        <li class="theme" @click="showClassify">{{className}} <cc-svg-icon  className="theme-size" :iconClass="showClass?'top-sort':'bottom-sort'"/></li>
        <li @click="filterData(1)" :class="{'theme':params.order_by_type == 1}">最新</li>
        <li @click="filterData(2)" :class="{'theme':params.order_by_type !== 1}">价格 <cc-svg-icon  :className="params.order_by_type !== 1 ? 'theme-size' :'size'" :iconClass="priceSort"/></li>
        <li @click="showDrawer = true">筛选<van-icon name="filter-o" /></li>
    </ul>
    <cc-main>
      <!-- 商品列表 -->
      <skeleton v-if="showSkeleton"/>
      <van-list
        v-else
        ref="list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <cc-not-order
          :isRouter="true"
          :show="false"
          url="/shopping-cart/distributor"
          v-if="list.length === 0 && m_loading === false"
          tip="亲，暂无采购商品">
        </cc-not-order>
        <cc-animation-list>
          <div class="goods" v-for="(product,index) in list" :key="index">
            <div class="goods-img"><img :src="product.image_list" alt=" "></div>
            <ul class="goods-info">
              <li class="f14 fw-bold">{{product.name}}</li>
              <li>{{product.specif}}</li>
              <li>{{product.company}}</li>
              <li><van-tag type="danger" color="#F92D6C" style="margin-right:10px;">供</van-tag>{{product.supplier}}</li>
              <li class="mb6">采购价：<span class="goods-info-price">￥{{product.price}}</span></li>
              <li class="goods-info-num">
                <cc-stepper v-model="product.num" :min="1"/>
                <cc-svg-icon icon-class="shopping-cart" @click.native="addCart(index)" size="18px" className="shopping-cart"/>
              </li>
            </ul>
          </div>
        </cc-animation-list>
      </van-list>
    </cc-main>
    <!-- 分类model -->
    <div class="class-model" v-show="showClass" @click.prevent="showClass=false">
          <van-tree-select
            @click.native="$event.stopPropagation()"
            :items="classifyOptions"
            :main-active-index="mainActiveIndex"
            :active-id="activeId"
            @navclick="onNavClick"
            @itemclick="onItemClick"
          />
    </div>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import Skeleton from './skeleton.vue'
import { Popup, Collapse, CollapseItem, Icon, List, Stepper, Tag, TreeSelect, Toast, Search } from 'vant'
import ListMixin from '@/mixins/list'
import { mapActions, mapGetters } from 'vuex'
import { ResultCode } from '~const/ResultCode'
import { scrollTop } from '~utils'
Vue.use(Collapse)
  .use(CollapseItem)
  .use(Popup)
  .use(Icon)
  .use(List)
  .use(Stepper)
  .use(Tag)
  .use(TreeSelect)
  .use(Toast)
  .use(Search)
export default {
  mixins: [ ListMixin ],
  components: {
    Skeleton
  },
  data () {
    return {
      className: '全部分类',
      params: {
        parent_category_id: 0,
        category_id: 0,
        order_by_type: 1,
        tag_id: 0,
        factory_id: 0,
        supplier_id: 0,
        search: ''
      },
      filterState: 1,
      num: 0,
      showClass: false,
      loading: false,
      finished: false,
      showDrawer: false,
      showSkeleton: true,
      activeNames: [0],
      filterSelect: [
        {
          id: 1,
          title: '标签',
          prop: 'tag',
          value: '',
          arr: [

          ]
        },
        {
          id: 2,
          title: '生产厂家',
          prop: 'factory',
          value: '',
          arr: [

          ]
        },
        {
          id: 3,
          title: '供应商',
          prop: 'supplier',
          value: '',
          arr: [

          ]
        }
      ],
      list: [],
      classifyOptions: [
        {
          // 导航名称
          text: '所有城市',
          // 该导航下所有的可选项
          children: [
            {
              // 名称
              text: '温州',
              // id，作为匹配选中状态的标识
              id: 1
            },
            {
              text: '杭州',
              id: 2
            }
          ]
        }
      ],
      // 左侧高亮元素的index
      mainActiveIndex: 0,
      // 被选中元素的id
      activeId: 1,
      firstName: ''
    }
  },

  computed: {
    ...mapGetters(['getClassifyOptions', 'getProductList', 'getCartStatus']),
    priceSort () {
      return this.params.order_by_type === 2 ? 'bottom-sort' : (this.params.order_by_type === 3 ? 'top-sort' : 'no-sort')
    }
  },

  created () {
    this.loadClassifyOptions()
    this.loadData()
  },
  methods: {
    ...mapActions(['GOODS_NUM', 'LOAD_CLASSIFY_DATA', 'LOAD_PRODUCT_LIST', 'ADD_CART']),
    /**
     * @description 加载分类选项
     */
    async loadClassifyOptions () {
      await this.LOAD_CLASSIFY_DATA()
      let allClassify = { id: 0, text: '全部分类', children: [{ id: 0, text: '全部分类' }] }
      if (this.getClassifyOptions.status === ResultCode.SUCCESS) {
        this.getClassifyOptions.data.category.forEach(item => { // 整理一级分类的全部分类
          if (item.son.length > 0) {
            let newArr = item.son.map(prop => {
              return {
                id: prop.id,
                text: prop.category_name
              }
            })
            allClassify.children = [...allClassify.children, ...newArr]
          }
        })
        // 拿到分类的数据
        this.classifyOptions = [allClassify, ...this.mapClassifyOptions(this.getClassifyOptions.data.category)]
        this.mapFiltrate(this.getClassifyOptions.data)
      }
    },
    /**
     * @description 整理分类数据
     */
    mapClassifyOptions (data) {
      let allClassify = { id: 0, text: '全部分类' }
      return data.map(item => {
        if (item.son) {
          return {
            id: item.id,
            text: item.category_name,
            children: [allClassify, ...this.mapClassifyOptions(item.son)]
          }
        } else {
          return {
            id: item.id,
            text: item.category_name
          }
        }
      })
    },
    search () {
      this.mReset()
      const reset = true
      scrollTop(this.$refs.list) // 用于回到顶部
      this.loadData(reset)
    },
    /**
     * @description 加载商品列表
     */
    async loadData (reset) {
      if (reset) {
        this.list = []
      }
      this.mRequest()
      let data = this.params
      data.page = this.m_page.curr
      data.page_size = this.m_page.limit
      await this.LOAD_PRODUCT_LIST(data)
      this.$tips(this.getProductList, {
        tip: false
      }, res => {
        this.showSkeleton = false
        const data = res

        if (data.list.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          let mapData = data.list.map(item => {
            return {
              id: item.id,
              image_list: item.image_list[0] || this.$notImg,
              name: item.general_name,
              specif: item.norms,
              company: item.factory.name,
              supplier: item.supplier.name,
              price: item.price,
              num: 1
            }
          })
          this.list = [...this.list, ...mapData]
          if (mapData.length < 10) {
            this.mEnd()
          }
        }
      })
      this.mSuccess()
    },

    /**
     * @description 整理筛选抽屉的数据
     */
    mapFiltrate (data) {
      this.filterSelect.forEach(item => {
        item.arr = data[item.prop].map(prop => {
          return {
            id: prop.id,
            name: prop.name,
            state: false
          }
        })
      })
    },
    /**
     * @description 点击最新 默认排序
     */
    filterData (index) {
      if (index === 1) { // 最新
        this.params.order_by_type = index
      } else if (index === 2 && (this.params.order_by_type === 1 || this.params.order_by_type === 3)) { // 降序
        this.params.order_by_type = index
      } else { // 升序
        this.params.order_by_type = 3
      }
      this.search()
    },
    /**
     * @description 分类左侧
     */
    onNavClick (index) {
      this.firstName = this.classifyOptions[index].text
      this.mainActiveIndex = index
      this.params.parent_category_id = this.classifyOptions[index].id
    },
    /**
     * @description 点击分类右侧
     */
    onItemClick (data) {
      if (data.id !== 0) {
        this.className = data.text
      } else {
        this.className = this.firstName
      }
      this.activeId = data.id
      this.params.category_id = data.id
      this.search()
      this.showClass = false
    },
    /**
     * @description 分类筛选
     */
    showClassify () {
      this.showClass = !this.showClass
    },
    /**
     * @description 点击筛选按钮
     * @param {index} 一级 索引
     * @param {key} 二级索引
     */
    selectedFliter (index, key) {
      let selectData = this.filterSelect[index]['arr'][key]
      if (selectData.state) {
        selectData.state = false
        this.filterSelect[index].value = ''
      } else {
        this.filterSelect[index]['arr'].forEach(item => {
          item.state = false
        })
        this.filterSelect[index].value = selectData.name
        selectData.state = true
      }
    },
    /**
     * @description 点击重置按钮
    */
    reset () {
      this.filterSelect.forEach(item => {
        item.value = ''
        item.arr.forEach(prop => {
          prop.state = false
        })
      })
    },
    /**
     * @description 点击确定按钮
    */
    confirm () {
      this.filterSelect.forEach(item => {
        this.getSelectedFliterOptions(item)
      })
      this.search()
      this.showDrawer = false
    },
    /**
     * @description 获取筛选的抽屉里面的被选中的
     */
    getSelectedFliterOptions (data) {
      let item = data.arr.filter(prop => {
        return prop.state === true
      })
      if (item[0]) {
        this.params[data.prop + '_id'] = item[0].id
      } else {
        this.params[data.prop + '_id'] = 0
      }
    },
    /**
     *@description 增加到购物车
     */
    async addCart (index) {
      const data = {
        plan_goods_id: this.list[index].id,
        quantity: this.list[index].num
      }
      await this.ADD_CART(data)
      const { status, info } = this.getCartStatus
      if (status === ResultCode.SUCCESS) {
        this.GOODS_NUM()
        Toast({
          message: info.msg,
          duration: 800
        })
      }
    },
    /**
     *@description 点击搜索
     */
    toSearch () {
      this.search()
    }

  }
}

</script>
<style lang='scss' scoped>
.filter-tabs{
  height: 44px;
  text-align: center;
  display: flex;
  width: 100%;
  align-items: center;
  background:rgba(255,255,255,1);
  border-bottom: 1px solid rgba(229,229,229,1);
  li{
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .theme{
    color: var(--APP_theme_color);
  }
  .theme-size{
    color: var(--APP_theme_color);
    width: 11px!important;
    margin-left: 3px;
  }
  .size{
     width: 13px!important;
     margin-left: 3px;
  }
}
.filtrate-model{
  .btns{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    span{
      height: 28px;
      border-radius: 14px;
      display: inline-block;
      min-width: 86px;
      font-size: 12px;
      background:rgba(241,241,241,1);
      color: #333333;
      margin: 10px 15px 10px 0;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .active{
       border: 1px solid var(--APP_theme_color);
       background: #ffffff;
       color: var(--APP_theme_color);
    }
  }
  /deep/{
    .van-cell__title{
      display: inline-block;
      flex: none;
      width: 100px;
    }
    .van-cell__value{
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--APP_theme_color);
    }
  }
  .bottom-btns{
    border-top: 1px solid rgba(238,238,238,1);
    height: 60px;
    z-index: 10;
    width: 100%;
    position: fixed;
    right: 0;
    bottom: 0;
    span{
      width: 50%;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      font-size: 15px;
      &:nth-of-type(2){
        background: var(--APP_theme_color);
        color: #ffffff;
      }
    }
  }
  /deep/{
    .van-cell:not(:last-child)::after {
      border-bottom: none;
    }
  }
}
.goods{
  width: 100%;
  background: #ffffff;
  height: 140px;
  padding: 10px;
  display: flex;
  margin-bottom: 8px;
  background:rgba(255,255,255,1);
  box-sizing: border-box;
  box-shadow: $box-shadow-base;
  &-img{
    width: 120px;
    height: 120px;
    background: #cccccc;
    img{
      width: 100%;
      height: 100%;
    }

  }
  &-info{
    margin-left: 10px;
    width: 225px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &-price{
      color: #f92d6c;
      font-weight: bolder;
    }
    &-num{
      height: 32px;
      display: flex;
      align-self: center;
      .cc-stepper{
        float: left;
      }
    }
    li{
      width: 225px;
      overflow: hidden;/*超出部分隐藏*/
      white-space: nowrap;/*不换行*/
      text-overflow:ellipsis;/*超出部分文字以...显示*/
    }
    .shopping-cart{
      display: flex;
      align-self: center;
      margin-left: 10px;
      color: var(--APP_theme_color);

    }
  }
}
.class-model{
  position: fixed;
  height: calc(100vh - 0.89rem);
  width: 100%;
  top: 0.89rem;
  left: 0;
  background-color: rgba(0,0,0,.7);
  z-index: 9;
  /deep/{
    .van-tree-select__selected{
      position:absolute!important;
    }
  }
}
.line{
  height: 88px;
}
.search-input{
  height:100%;
  width:280px;
  padding:0;
  border-radius:10px;
  /deep/{
    .van-field__left-icon .van-icon{
      color:#777777;
    }
  }
}
.search-btn{
  font-size: 12px;
  width: 100%;
}
.fw-bold{
  font-weight: bold;
}
.van-list{
  height: calc(100vh - 140px);
  overflow: scroll;
}
.cc-main{
  overflow: hidden;
}
</style>
